// extracted by extract-css-chunks-webpack-plugin
module.exports = {"grid":"app-components-artistslist-artistslist--grid"};